var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 31 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillOpacity: 0.7,
  fillRule: "evenodd",
  d: "M21.704 10.392a1.445 1.445 0 0 1 1.967 2.118L13.26 22.183a.5.5 0 0 1-.68 0l-6-5.574a1.445 1.445 0 1 1 1.967-2.118l4.373 4.062z",
  clipRule: "evenodd"
})));
export default SvgCheckbox;